import { memo } from 'react';
import GeneralFiltersOptions from './GeneralFiltersOptions';
import GeneralYearPicker from './GeneralYearPicker';
import GeneralSearchBar from './GeneralSearchBar';
import MarketplaceFilter from './MarketplaceFilter';

const GeneralTableFilters = memo(() => {
	return (
		<>
			<GeneralSearchBar />

			<GeneralFiltersOptions />

			<GeneralYearPicker />

			<MarketplaceFilter />
		</>
	);
});

export default GeneralTableFilters;
